import React from 'react'
import { Container, Typography, Link } from '@material-ui/core'
import Mapa from './Mapa'
import makeStyles from './style'
import FormContato from './FormContato'
import facebookIcon from '../images/facebookicon.png'
import linkedinIcon from '../images/linkedinicon.png'


export default function Contato() {
    const { bigContainer, container, title, description, addressContainer, containerContato, fbIcon } = makeStyles()

    return (
        <Container className={bigContainer}>
            <Container className={containerContato}>
                <Container className={addressContainer}>
                    <Typography variant='h4' className={title}>Informações para contato</Typography>
                    <Typography variant='body2' color='text.secondary' className={description}>
                    M A SERVIÇOS DE USINAGEM LTDA <br />
                    Rua Humberto Bereta, 321 <br />
                    Amparo, SP - Brasil - CEP 13900 220 <br />
                    <br />
                    Fone: 0055 (19) 3807 9947 <br />
                    <br />
                    Fax: 0055 (19) 3807 4072 <br />
                    <br />
                    Mail: <Link 
                        to='javascript:void(0)'
                        onClick={() => window.location = 'mailto:vendas@mausinagem.ind.br'}
                    >
                        vendas@mausinagem.ind.br
                    </Link><br />
                    <br />
                    <Link 
                        href="https://m.facebook.com/M-A-Serviços-de-Usinagem-Ltda-111535214642026/posts/?ref=page_internal&__nodl&refsrc=deprecated&_rdr"
                        style={{display: 'flex', flexDirection: 'row'}}
                    >
                        <img src={facebookIcon} className={fbIcon}/>Facebook
                    </Link>
                    <Link 
                        href="https://www.linkedin.com/company/m-a-servi%C3%A7os-de-usinagem-ltda/"
                        style={{display: 'flex', flexDirection: 'row'}}
                    >
                        <img src={linkedinIcon} className={fbIcon}/>Linkedin
                    </Link>
                    </Typography>
                </Container>
                <Mapa/>
            </Container>
            {/* <Container className={container} style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Typography variant='h4' className={title}>Envie uma mensagem</Typography>
                <FormContato />
            </Container> */}
        </Container>
    )
}